import React, { useEffect } from 'react';

const LanguageSwitcher = () => {
  useEffect(() => {
    // Load the Google Translate script
    const addGoogleTranslateScript = () => {
      if (!document.getElementById('google-translate-script')) {
        const script = document.createElement('script');
        script.id = 'google-translate-script';
        script.type = 'text/javascript';
        script.src = '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
        script.async = true;
        document.body.appendChild(script);
      }
    };

    // Initialize the translate widget
    window.googleTranslateElementInit = () => {
      new window.google.translate.TranslateElement(
        {
          pageLanguage: 'en',
          includedLanguages: 'en,es',
          layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
        },
        'google_translate_element'
      );
    };

    // Add the script
    addGoogleTranslateScript();
  }, []);
 
  return (
    <div>
      {/* TODO: style that we need to move */}
      <style>
        {`
        /* Hide the Google Translate toolbar */
        .VIpgJd-ZVi9od-ORHb-OEVmcd.skiptranslate {
            display: none;
        }

        /* Hide the Google Translate icon */
        .goog-te-gadget-icon{
            display: none;
        }
        
        /* Style the Google Translate element */
        .goog-te-gadget-simple {
        font-size: 15px;
        padding: 5px;
        }
        `}
      </style>
      {/* Google Translate Element */}
      <div id="google_translate_element"></div>
    </div>
  );
};

export default LanguageSwitcher;
